<template>
  <div>    
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficodoughnut :rotulo="'DETALHES:'"
                                :legendas="legendassetorpro"
                                :dados="dadossetorpro"
            ></graficodoughnut>
        </div>
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoDoughnut from '../../components/cmpgraficodoughnut.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "comprasetores",

  components:{
    'graficodoughnut'       : GraficoDoughnut,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        dadossetorpro        : [],
        legendassetorpro : [],
        usuariologado           : this.$store.state.usuario,

    }
  },
  props: [
      'utodasfiliais',
      'idfilialmeta',
      'pdtini',
      'pdtfim',
      'lstfiliais',
    
  ],
  methods:{
        mtdexecutadash(){
            var vself           = this;             
            vself.$emit('handlerLoader', true);
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            let filtro          = '';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtro  = ' and pc.idfilial in (' + stringfilial + ')';
            }
            // let filtrocp        = vself.mtdfiltropesquisacp();
            let parametros      = [
                {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor  : 'dashboard'},
                {parametro: 'periodo',      valor : periodo},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'filtro',       valor  : filtro},
                // {parametro: 'filtrocp',     valor  : filtrocp},
                // {parametro: 'dini',         valor  : util.InverterData(vself.pdtini)},
                // {parametro: 'dfim',         valor  : util.InverterData(vself.pdtfim)}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
            retorno.then(function (response) {
                

                vself.dadossetorpro     = response.data.setorpro;
                vself.legendassetorpro  = util.gerardadoslegendagrafico(vself.dadossetorpro);

                // vself.dadosgrupospro    = response.data.grupopro;
                // vself.legendasgrupospro = util.gerardadoslegendagrafico(vself.dadosgrupospro);

                // vself.dadospedidosfil   = response.data.comprasfil;
                // vself.legendaspedidofil = util.gerardadoslegendagrafico(vself.dadospedidosfil);

                // vself.dadosmarca        = response.data.comprasmarca;
                // vself.legendasmarca     = util.gerardadoslegendagrafico(vself.dadosmarca);

        
                // vself.dadosmeta = [
                //     {value: parseFloat(response.data.atingida), name: 'ATINGIDA'},
                //     {value: parseFloat(response.data.restante), name: 'RESTANTE'}                       
                    
                // ];
                // vself.legendasmeta = util.gerardadoslegendagrafico(vself.legendasmeta);

                // vself.mtdprocessadadosgraficoline(response.data.prevrecebimento);
                // vself.mtdprocessadadosgraficolinepag(response.data.prevpagamento);
                // vself.mtdprocessadadosgraficolinecontas(response.data.contaspagar)
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.$emit('handlerLoader', false);
            });
        },
  },
  mounted(){
    setTimeout(() => {
        this.mtdexecutadash();
    }, 3000);
  },
  computed:{
            
  },
}
</script>
